import { render, staticRenderFns } from "./DobleTorta.vue?vue&type=template&id=ee8a6962&"
import script from "./DobleTorta.vue?vue&type=script&lang=js&"
export * from "./DobleTorta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports